import { useEffect } from 'react';

export const useDebounce = (setDebounce, query) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounce(false);
    }, 600);

    return () => {
      setDebounce(true);
      clearTimeout(timeout);
    };
  }, [setDebounce, query]);
};
